import { render } from "./ExtranetFeatureFlagAudit.vue?vue&type=template&id=52817196&scoped=true"
import script from "./ExtranetFeatureFlagAudit.vue?vue&type=script&lang=js"
export * from "./ExtranetFeatureFlagAudit.vue?vue&type=script&lang=js"

import "./ExtranetFeatureFlagAudit.vue?vue&type=style&index=0&id=52817196&scoped=true&lang=css"

import exportComponent from "/home/forge/mymembership.id/releases/81403580/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52817196"]])

export default __exports__